module.exports = __webpack_public_path__ + "static/img/image003.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/image003.gif
// module id = ajpa
// module chunks = 1